import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { Row, Column, Drawer } from '@oliasoft-open-source/react-ui-library';
import { SectionsList } from 'views/settings/templates/activity-model/sections.list';
import { OperationsList } from 'views/settings/templates/activity-model/operations.list';
import { ActivitiesList } from 'views/settings/templates/activity-model/activities.list';
import { OperationModal } from 'views/settings/templates/activity-model/operation.modal';
import { OperationDeleteModal } from 'views/settings/templates/activity-model/operation-delete.modal';
import { ActivityDeleteModal } from 'views/settings/templates/activity-model/activity-delete.modal';
import { ActivityModal } from 'views/settings/templates/activity-model/activity.modal';
import { ImportOperationModal } from 'views/settings/templates/activity-model/import-operation.modal';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import {
  sectionTypeSelected,
  operationSelected,
  showOperationsFormUpdated,
  showDeleteOperationsModalUpdated,
  removeOperation,
  addInitialActivity,
  showActivitiesForm,
  closeActivitiesForm,
  updateActivity,
  removeActivity,
  showDeleteActivitiesModalUpdated,
  reorderActivities,
  reorderOperationsInSettings,
  importOperations,
  showImportOperationModalUpdated,
} from 'src/store/entities/templates/templates';
import {
  selectIsAddingTemplates,
  selectTemplatesFormVisibility,
  selectTemplatesModalVisibility,
  selectSectionTypes,
  getSelectedId,
} from 'src/store/entities/templates/selectors';
import { ImportFromTemplateModal } from 'src/views/activity-model/tasks/import-from-template-modal';

import styles from '../templates.module.less';

const ActivityModel = ({
  templates,
  activeSection,
  activityModel,
  activeOperation,
  activeActivity,
  showOperationsForm,
  showActivityForm,
  showOperationsFormUpdated,
  showDeleteOperationsModal,
  showDeleteActivitiesModal,
  showImportOperationModal,
  showDeleteOperationsModalUpdated,
  showDeleteActivitiesModalUpdated,
  showImportOperationModalUpdated,
  closeActivitiesForm,
  selectedId,
  activeTemplate,
  sectionTypes,
  sectionTypeSelected,
  operationSelected,
  addInitialActivity,
  reorderActivities,
  showActivitiesForm,
  removeActivity,
  removeOperation,
  updateActivity,
  importOperations,
  reorderOperationsInSettings,
  depthUnit,
  ROPUnit,
  durationUnit,
  isLoading,
  entity,
  operations,
}) => {
  const { company: companyId } = useParams();

  const [sectionDrawerWidth, setSectionDrawerWidth] = useState(260);
  const [operationDrawerWidth, setOperationDrawerWidth] = useState(300);
  const [showImportFromTemplateModal, setShowImportFromTemplateModal] = useState(false);
  const [isLinkedTaskImport, setIsLinkedTaskImport] = useState(false);
  const [activityParentId, setActivityParentId] = useState(null);

  const selectSetionType = (sectionId) => {
    sectionTypeSelected({ sectionId, entity });
  };

  const onDeleteOperation = () => removeOperation(selectedId, templates, entity, companyId);
  const onDeleteActivity = () => removeActivity(selectedId, templates, entity, companyId);

  const handleTaskImportModal = (isOpen) => {
    setShowImportFromTemplateModal(isOpen);
  };

  return (
    <>
      <div className={styles.activityModelTabWrapper}>
        <Row height="100%" spacing={0}>
          <Drawer
            width={sectionDrawerWidth}
            closedWidth={50}
            open
            button
            border
            onResize={(width) => setSectionDrawerWidth(width)}
          >
            <Column scroll width="250px" borderRight spacing={0}>
              <SectionsList
                sectionTypes={sectionTypes}
                sectionTypeSelected={selectSetionType}
                entity={entity}
                operations={operations}
              />
            </Column>
          </Drawer>
          {activeSection && (
            <Drawer
              width={operationDrawerWidth}
              closedWidth={50}
              open
              button
              border
              onResize={(width) => setOperationDrawerWidth(width)}
            >
              <Column scroll borderRight width="350px" spacing={0}>
                <OperationsList
                  entity={entity}
                  templates={templates}
                  isLoading={isLoading}
                  reorderOperationsInSettings={reorderOperationsInSettings}
                  activityModel={activityModel}
                  operationSelected={operationSelected}
                  setOperationModalVisible={showOperationsFormUpdated}
                  showDeleteOperationsModalUpdated={showDeleteOperationsModalUpdated}
                  showImportOperationModalUpdated={showImportOperationModalUpdated}
                />
              </Column>
            </Drawer>
          )}
          {activeOperation && (
            <Column scroll>
              <ActivitiesList
                entity={entity}
                templates={templates}
                activeOperation={activeOperation}
                showDeleteActivitiesModalUpdated={showDeleteActivitiesModalUpdated}
                addInitialActivity={addInitialActivity}
                reorderActivities={reorderActivities}
                showActivitiesForm={showActivitiesForm}
                handleTaskImportModal={handleTaskImportModal}
                setIsLinkedTaskImport={setIsLinkedTaskImport}
                setActivityParentId={setActivityParentId}
              />
            </Column>
          )}
        </Row>
      </div>
      {showOperationsForm && (
        <OperationModal
          entity={entity}
          templates={templates}
          operation={activeOperation}
          activeSection={activeSection}
          setModalVisible={showOperationsFormUpdated}
          isAdding={isLoading}
          depthUnit={depthUnit}
        />
      )}
      {showActivityForm && (
        <ActivityModal
          entity={entity}
          templates={templates}
          activity={activeActivity}
          activeOperation={activeOperation}
          isAdding={isLoading}
          depthUnit={depthUnit}
          ROPUnit={ROPUnit}
          durationUnit={durationUnit}
          closeActivitiesForm={closeActivitiesForm}
          updateActivity={updateActivity}
        />
      )}
      {showDeleteOperationsModal && (
        <OperationDeleteModal onDelete={onDeleteOperation} setModalVisible={showDeleteOperationsModalUpdated} />
      )}
      {showDeleteActivitiesModal && (
        <ActivityDeleteModal onDelete={onDeleteActivity} setModalVisible={showDeleteActivitiesModalUpdated} />
      )}
      {showImportOperationModal && (
        <ImportOperationModal
          entity={entity}
          templates={templates}
          activeSection={activeSection}
          activeTemplate={activeTemplate}
          showImportOperationModalUpdated={showImportOperationModalUpdated}
          importOperations={importOperations}
        />
      )}
      {showImportFromTemplateModal && (
        <ImportFromTemplateModal
          handleTaskImportModal={handleTaskImportModal}
          isLinked={isLinkedTaskImport}
          activeOperation={activeOperation}
          parentId={activityParentId}
          templates={templates}
          companyId={companyId}
        />
      )}
    </>
  );
};

const mapStateToProps = (state, { templates }) => {
  const sectionTypes = selectSectionTypes(state);

  const activeSection = sectionTypes.find((item) => item.active);
  const templateIndex = templates.findIndex((item) => item.active);
  const operations = templates[templateIndex].activityModel;
  const activityModel = activeSection
    ? operations.filter((item) => item.linkedSectionType === activeSection.linkedSectionId)
    : [];
  const activeOperation = activityModel.find((item) => item.active);
  const activeActivity = activeOperation?.activities && activeOperation.activities.find((item) => item.active);

  const isLoading = selectIsAddingTemplates(state);
  const formsVisibility = selectTemplatesFormVisibility(state);
  const modalsVisibility = selectTemplatesModalVisibility(state);
  const selectedId = getSelectedId(state);

  return {
    activeSection,
    activityModel,
    activeOperation,
    activeActivity,
    ...formsVisibility,
    ...modalsVisibility,
    selectedId,
    activeTemplate: templateIndex,
    sectionTypes,
    isLoading,
    operations,
  };
};

const mapDispatchToProps = {
  showOperationsFormUpdated,
  showDeleteOperationsModalUpdated,
  showDeleteActivitiesModalUpdated,
  showImportOperationModalUpdated,
  sectionTypeSelected,
  operationSelected,
  showActivitiesForm,
  closeActivitiesForm,
  removeOperation,
  addInitialActivity,
  updateActivity,
  removeActivity,
  reorderActivities,
  reorderOperationsInSettings,
  importOperations,
};

const Container = withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(ActivityModel));

export { Container as ActivityModel };
